var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 513.53 618.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430,172.58c49.24,67.28,80.56,143.57,68.5,215.24S431,526.64,369.22,541.39s-130-22.92-204.76-55.7S8.7,425.24.66,382.94,57.94,283.73,111,215.48,205.05,67.89,259.16,57.4,380.68,105.3,430,172.58Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.48,222.16c4.66,4.66,73.82,143,74.4,148.81s-19,169.22-19,169.22H383.57s-13.22-156.22-15-159.42-68-68.86-68-68.86S325.67,221.19,359.48,222.16Z",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,364.34h0l55.19-48.13c-20.4-41.32-45.94-91.28-48.71-94-33.81-1-58.87,89.75-58.87,89.75S332.91,343.93,353,364.34Z",
    fill: "#5fc5d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,411.34c4.49,46.31,11.47,128.85,11.47,128.85h31.27s9.78-81.38,15.32-131.32Z",
    fill: "#fd8369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,266.45c-1.85,8.55-32.93,142.21-32.93,142.21L76.81,410.41l-5.25,28.17S220.75,465.53,226,462.87C241.36,455.09,341,258.29,342.57,241S236.21,266.45,236.21,266.45Z",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17,388.35C304.6,328,341.63,251.49,342.57,241c1.56-17.29-106.36,25.45-106.36,25.45-1.25,5.78-15.85,68.72-25.19,108.9C218.69,373.43,258.07,373.29,272.17,388.35Z",
    fill: "#6bd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,160.68s-27.3,30.41-29.45,33-56.27,46.45-59.62,49.09,4.31,14.12,9.58,11.73,71.35-36.39,76.13-40,33-26.33,33-26.33Z",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.43,
    cy: 256.65,
    rx: 15.44,
    ry: 11.13,
    transform: "translate(-136.94 89.02) rotate(-35.78)",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,120.26c8,3.14,38.7,24.25,43.51,25.74s68.89,14.68,68.89,14.68c.74,2.91,2,11.61,0,15.5-5,.56-69.63-.74-72.78-1.67s-51.11-17.4-51.11-17.4Z",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 466.19,
    cy: 167.38,
    rx: 16.48,
    ry: 10.34,
    transform: "translate(-22.32 85.48) rotate(-10.23)",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.64,109.71c6.64-20.47,58.88-4.43,62.47,3s-4,49.17-14.22,50.44S274.05,130,280.64,109.71Z",
    fill: "#ffc78e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.3,102.73c73.09-24,111.35,99.85,116.56,121.86-9.59,23.27-93.44,62.29-125.27,46.2C224.9,264.88,184.77,122.55,245.3,102.73Z",
    fill: "#ffd98e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.42,129.12C252.06,151,206.78,195.6,197.5,195.6s-40.31-30.6-38-40.31S207.84,106.33,230.42,129.12Z",
    fill: "#ffe4ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.33,408.87,76.81,410.41l-5.25,28.17s67.2,12.14,113,19.32Z",
    fill: "#fd8369"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.56 412.4 66.91 439.14 30.16 459.56 4.08 455.74 0 444.54 38.2 417.14 71.56 412.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.05 545.03 377.76 579.31 441.74 609.4 453.55 595.88 413.56 549.6 413.37 543.7 384.05 545.03"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.98,
    cy: 568.22,
    r: 50.56,
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,52.6c1.75,7,4.59,46.39,2.88,57.94,6.25,7.2,28.79,9,34.69,2.42-2.27-6.81-2.14-23.47-1.13-29.73C273.29,79.27,236.21,52.6,236.21,52.6Z",
    fill: "#d38d6a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.04,
    cy: 43.76,
    rx: 43.86,
    ry: 34.96,
    transform: "translate(193.3 304.86) rotate(-83.3)",
    fill: "#e49d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,36.5c3.6-2.46.95-7.76,3.6-8.9,2.39-1,26.76-1.74,43.72,5.68C299.79,15.71,288.33,2,273.15.19,254.48-2,237.07,14.71,233.57,37.82,242,38.35,252.81,38.13,255.19,36.5Z",
    fill: "#fd8369"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.31,
    cy: 45.4,
    rx: 11.36,
    ry: 12.31,
    fill: "#e49d75"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8fcdd8eb.svg";
export { ForwardRef as ReactComponent };